import { addClass, removeClass } from "./common";

enum SelectorType {
    list,
    select
}

export default class DimensionSelector {
    
    private baseElement: HTMLElement;
    private selectorType: SelectorType;
    private _dimNumber: number;

    public get dimNumber(): number {
        return this._dimNumber;
    }

    private selectDimensionValue: (dimNumber: number, dataValue: string) => Promise<void>;


    constructor(baseElement: HTMLElement, selectDimensionValue: (dimNumber: number, dataValue: string) => Promise<void>) {
        this.baseElement = baseElement;
        this.selectDimensionValue = selectDimensionValue;
        this._dimNumber = Number(baseElement.dataset.dimNumber);
        this.selectorType = baseElement.dataset.selectorType === "select" ? SelectorType.select : SelectorType.list;
        this.init();
    }

    public selectValue(value: string){
        switch(this.selectorType) {
            case SelectorType.select:
                (this.baseElement as HTMLSelectElement).value = value;
                break;
            case SelectorType.list:
                this.baseElement.querySelectorAll('[data-value].selected').forEach(e => removeClass(e as HTMLElement, 'selected'));
                this.baseElement.querySelectorAll(`[data-value="${value}"]`).forEach(e => addClass(e as HTMLElement, 'selected'));
                break;
            default:
                throw new Error("Unrecognized selector type: " + this.selectorType);
        }
    }

    private init() {
        switch(this.selectorType) {
            case SelectorType.select:
                this.initSelect(this.baseElement as HTMLSelectElement);
                break;
            case SelectorType.list:
                this.initList(this.baseElement as HTMLUListElement);
                break;
            default:
                throw new Error("Unrecognized selector type: " + this.selectorType);
        }
    }

    
    private initSelect(select: HTMLSelectElement) {
        select.addEventListener(
            'change', 
            async (evt: Event) => await this.selectDimensionValue(this._dimNumber, (evt.target as HTMLSelectElement).value));
    }

    private initList(list: HTMLUListElement) {
        const valueElements = list.querySelectorAll('[data-value]');
        valueElements.forEach(element => {
            if (!element.classList.contains('disabled')) {
                element.addEventListener(
                    'click',
                    async () => await this.selectDimensionValue(this._dimNumber, element.getAttribute('data-value'))
                )
            }
        });
    }
}
